import { render, staticRenderFns } from "./ConsentListForm.vue?vue&type=template&id=7ba83e11&"
import script from "./ConsentListForm.vue?vue&type=script&lang=js&"
export * from "./ConsentListForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports